// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__6AOUv","load5":"style_load5__39i-t"};